import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

const SimplebarWrapper = ({ children }) => {
  const simplebarWrapperRef = useRef();

  return (
    <SimpleBar style={{ overflowX: 'hidden !important' }} ref={simplebarWrapperRef}>
      {children}
    </SimpleBar>
  );
};

SimplebarWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.object.isRequired])
};

export default React.memo(SimplebarWrapper);
